import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SectorPage } from './sector';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    SectorPage,
  ],
  imports: [
    IonicPageModule.forChild(SectorPage),
    ComponentsModule
  ],
})
export class SectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/sector/sector.module.ts